// @ts-nocheck

/* eslint-disable sonarjs/no-duplicate-string */
import { getRelativeValue } from '../utils';

export const getBoundsTitle = (width, hasDate = true) => ({
  width: getRelativeValue(hasDate ? 360 : 280, width),
  fontSize: getRelativeValue(16, width),
  lineHeight: 1.2,
  fontFamily: 'BettingPoliticaExtraBold, sans-serif',
});

export const getBoundsBetTitle = (width) => ({
  width: getRelativeValue(270, width),
  fontSize: getRelativeValue(13, width),
  lineHeight: 1.3,
  fontFamily: 'BettingPoliticaExtraBold, sans-serif',
});

export const getBoundsLabel = (width) => ({
  width: getRelativeValue(270, width),
  fontSize: getRelativeValue(13, width),
  lineHeight: 1.3,
  fontFamily: 'BettingPoliticaExtraBold, sans-serif',
  paddingLeft: getRelativeValue(4, width),
  paddingTop: getRelativeValue(1, width),
});

export const getBoundsOdd = (width) => ({
  fontSize: getRelativeValue(25, width),
  x: getRelativeValue(320, width),
  width: getRelativeValue(75, width),
  height: getRelativeValue(24, width),
  lineHeight: 1.2,
  fontFamily: 'BettingPoliticaExtraBold, sans-serif',
});
